const main = resolve => require(['@/views/index/index.vue'], resolve) // 主页
const Chargeback = resolve => require(['@/views/riskManagement/chargeback/index.vue'], resolve) // 拒付

const riskTransactionManagement = resolve =>
  require(['@/views/riskManagement/riskTransactionManagement/index.vue'], resolve) // 风险订单管理

const BlackList = resolve =>
  require(['@/views/riskManagement/blackList/index.vue'], resolve) // 黑名单管理

const WhiteList = resolve =>
  require(['@/views/riskManagement/whiteList/index.vue'], resolve) // 白名单管理

const DisputeManage = resolve =>
  require(['@/views/riskManagement/disputeManage/index.vue'], resolve) // 争议订单管理

const DisputeDetail = resolve =>
  require(['@/views/riskManagement/disputeManage/detail.vue'], resolve) // 争议订单详情


export default [{
  path: '/index',
  component: main,
  children: [
    // 拒付调单管理
    {
      name: 'Chargeback',
      path: '/aq/chargeback',
      alias: ['/aq/chargeback.htm'],
      component: Chargeback
    },
    // 风险订单管理
    {
      name: 'RiskTransactionManagement',
      path: '/aq/riskTransactionManagement',
      alias: ['/aq/riskTransactionManagement.htm'],
      component: riskTransactionManagement
    },
    // 黑名单管理
    {
      name: 'BlackList',
      path: '/aq/blacklist',
      alias: ['/aq/blacklist.htm'],
      component: BlackList
    },
    // 白名单管理
    {
      name: 'WhiteList',
      path: '/aq/whiteList',
      alias: ['/aq/whiteList.htm'],
      component: WhiteList
    },
    // 争议订单管理
    {
      name: 'DisputeManage',
      path: '/aq/disputeManage',
      alias: ['/aq/disputeManage.htm'],
      component: DisputeManage
    },
    // 争议订单详情
    {
      name: 'DisputeDetail',
      path: '/aq/disputeDetail',
      alias: ['/aq/disputeDetail.htm'],
      component: DisputeDetail
    },
  ]
}]
